<template>
    <!--Sales main contianer-->
    <div class="sales-main-container">
        <!--Header Section-->
        <sales-header></sales-header>
        <!--Hero section-->
        <sales-hero></sales-hero>
        <!--Scheduling solution section-->
        <sales-scheduling-solution></sales-scheduling-solution>
        <!--Small teams section-->
        <sales-small-teams></sales-small-teams>
        <!--Customer support section-->
        <sales-customer-support></sales-customer-support>
        <!--Payments section-->
        <sales-payments></sales-payments>
        <!--Mobile apps section-->
        <sales-mobile-app></sales-mobile-app>
        <!--Calendar section-->
        <sales-calendar></sales-calendar>>
        <!--Notifications section-->
        <sales-notifications></sales-notifications>
        <!--Online portfolio section-->
        <sales-online-portfolio></sales-online-portfolio>
        <!--Online Booking section-->
        <sales-online-booking></sales-online-booking>
        <!--Marketing section-->
        <sales-marketing></sales-marketing>
        <!--Tutorials section-->
        <sales-tutorials></sales-tutorials>>
        <!--Free access section-->
        <sales-free-access></sales-free-access>
        <!--Footer section-->
        <sales-footer></sales-footer>
    </div>
</template>
<script>
import SalesHeader from "./sales/SalesHeader.vue";
import SalesHero from "./sales/SalesHero.vue";
import SalesSchedulingSolution from "./sales/SalesSchedulingSolution.vue";
import SalesSmallTeams from "./sales/SalesSmallTeams.vue";
import SalesCustomerSupport from "./sales/SalesCustomerSupport.vue";
import SalesPayments from "./sales/SalesPayments.vue";
import SalesMobileApp from "./sales/SalesMobile_app.vue";
import SalesCalendar from "./sales/SalesCalendar.vue";
import SalesNotifications from "./sales/SalesNotifications.vue";
import SalesOnlinePortfolio from "./sales/SalesOnlinePortfolio.vue";
import SalesOnlineBooking from "./sales/SalesOnlineBooking.vue";
import SalesMarketing from "./sales/SalesMarketing.vue";
import SalesTutorials from "./sales/SalesTutorials.vue";
import SalesFreeAccess from "./sales/SalesFreeAccess.vue";
import SalesFooter from "./sales/SalesFooter.vue";

export default {
    name: "SalesApp",

    data: function () {
        return {};
    },
    mounted: function () {},
    computed: {},

    components: {
        SalesHeader,
        SalesHero,
        SalesSchedulingSolution,
        SalesSmallTeams,
        SalesCustomerSupport,
        SalesPayments,
        SalesMobileApp,
        SalesCalendar,
        SalesNotifications,
        SalesOnlinePortfolio,
        SalesOnlineBooking,
        SalesMarketing,
        SalesTutorials,
        SalesFreeAccess,
        SalesFooter,
    },

    methods: {},
};
</script>
